import React from 'react';
import { ChartLine, TrendDown, TrendUp } from '@phosphor-icons/react';
import {
  Card, CardContent, CardHeader, CardTitle,
} from '../../components/ui/card';
import TrendCharts from '../../components/TrendCharts';

const TrendKpi = ({ label, value, deltaText, deltaIcon: Icon, deltaPositive }) => (
  <Card className="border-slate-200">
    <CardContent className="pt-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-slate-500">{label}</p>
          <p className="text-xl font-bold">{value}</p>
        </div>
        <div className={`flex items-center text-sm ${deltaPositive ? 'text-green-600' : 'text-red-600'}`}>
          <Icon size={16} />
          <span className="ml-1">{deltaText}</span>
        </div>
      </div>
    </CardContent>
  </Card>
);

export const AgencyTrendsTab = ({ stats }) => (
  <Card className="border-slate-200">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <ChartLine size={20} className="text-indigo-600" />
        Trend Analysis
      </CardTitle>
      <p className="text-sm text-slate-500">Compare performance metrics across time periods</p>
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <TrendKpi
          label="Claims Volume"
          value={stats.total_claims.toLocaleString()}
          deltaText="+12%"
          deltaIcon={TrendUp}
          deltaPositive
        />
        <TrendKpi
          label="Avg. Processing Time"
          value="3.2 days"
          deltaText="-8%"
          deltaIcon={TrendDown}
          deltaPositive
        />
        <TrendKpi
          label="Denial Rate"
          value="4.2%"
          deltaText="-2%"
          deltaIcon={TrendDown}
          deltaPositive
        />
        <TrendKpi
          label="EVV Compliance"
          value="96.8%"
          deltaText="+1.5%"
          deltaIcon={TrendUp}
          deltaPositive
        />
      </div>
      <TrendCharts showControls />
    </CardContent>
  </Card>
);

export default AgencyTrendsTab;
